import { datesToISO, swal } from "@";
import { DonationsSearchValues } from "@/features/operations/verifications/donations/types.ts";

// ============================================
// Confirmation Dialogs
// ============================================

// Show confirmation dialog before ignoring orders from verification
export const ignoreOrdersConfirmDialog = async (): Promise<boolean> => {
  const { isConfirmed } = await swal(
    "",
    "إستبعاد الطلبات المحددة من التوثيق",
    "نعم إستبعاد",
  );
  return isConfirmed;
};

// search handler
export const searchHandler = (search: DonationsSearchValues) => {
  return {
    searchKey: search.searchKey,
    stageName: search.stageName,
    toTime: datesToISO(search.toTime),
    fromTime: datesToISO(search.fromTime),
    smsSendingDateTimeFrom: datesToISO(search.smsSendingDateTimeFrom),
    smsSendingDateTimeTo: datesToISO(search.smsSendingDateTimeTo),
    projectIds: search.projectIds || [],
    projectAttributeId: parseInt(<string>search.projectAttributeId) || null,
    projectClassificationId:
      parseInt(<string>search.projectClassificationId) || null,
    isFirstStageVerified:
      search.isFirstStageVerified === ""
        ? null
        : search.isFirstStageVerified === "true",
  };
};
